import React from 'react';
import Select, { components } from 'react-select';
import { IDeliveryman, SelectValue } from 'src/types';
import { IconMotoboy, Container } from './styles';

interface Props {
  motoboyList: IDeliveryman[];
  defaultCustomer?: IDeliveryman;
  label?: string;
  onSelect(motoboy: IDeliveryman): void;
  showAll?: boolean;
  width?: string;
  margin?: string;
  height?: string;
  align?: string;
  fontSize?: string;
}

const custom = {
  control: (styles: any, state: any) => ({
    ...styles,
    width: '100%',
    height: '100%',
    backgroundColor: 'white',
    borderRadius: 10,
    borderColor: state.selectProps.error ? 'red' : 'transparent',
    ':hover': {
      ...styles[':hover'],
      borderColor: state.selectProps.error ? 'red' : 'transparent',
      cursor: 'pointer',
    },
    padding: 5,
    fontSize: 16,
    color: '#333',
    boxShadow: '1px 2px 5px rgba(0, 0, 0, 0.15)',
    alignContent: 'center',
  }),
  option: (styles: any, state: any) => ({
    ...styles,
    backgroundColor: state.isSelected ? '#333' : null,
    color: state.isSelected ? '#fff' : '#070606',
    ':active': {
      ...styles[':active'],
      backgroundColor: '#333',
      color: '#fff',
    },
  }),
  container: (styles: any) => ({
    ...styles,
    height: '100%',
  }),
};

const MotoboySelect: React.FC<Props> = ({
  motoboyList,
  onSelect,
  defaultCustomer,
  label,
  showAll,
  width,
  height,
  margin,
  align,
  fontSize,
}) => {
  const [options, setOptions] = React.useState<SelectValue[]>([]);

  const onChange = React.useCallback(
    (value: SelectValue | null) => {
      if (value) {
        const motoboySelect = motoboyList.find(
          (motoboy) => motoboy.motoboyId?.toString() === value.value,
        );
        if (motoboySelect) {
          onSelect(motoboySelect);
        } else {
          onSelect({} as IDeliveryman);
        }
      }
    },
    [onSelect, motoboyList],
  );

  React.useEffect(() => {
    const optionsList: SelectValue[] = [];

    if (showAll) optionsList.push({ label: 'Todos', value: '-1' });

    motoboyList.forEach((motoboy) => {
      const id = motoboy.motoboyId?.toString();
      optionsList.push({ value: id ?? '-1', label: motoboy.name });
    });
    setOptions(optionsList.concat());
  }, [motoboyList, showAll]);

  return (
    <Container width={width} heigth={height} alignContent={align} margin={margin}>
      <Select
        defaultValue={{
          value: defaultCustomer?.name || label || 'Selecione',
          label: defaultCustomer?.name || label || 'Selecione',
        }}
        options={options}
        onChange={onChange}
        styles={custom}
        components={{
          Control: ({ children, ...props }) => (
            <components.Control {...props}>
              <IconMotoboy fontSize={fontSize} /> {children}
            </components.Control>
          ),
        }}
      />
    </Container>
  );
};

export default MotoboySelect;
